module.exports = __webpack_public_path__ + "static/illustration-transfusion-reaction-symptoms@2x-e926f12cfdb85bc8e0704d6b0390ae98.png";